module.exports = __webpack_public_path__ + "static/img/logo.e1c0f84a.png";